import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ArrangementModalPage } from './arrangement-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ArrangementModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArrangementModalPageRoutingModule {}
